webpackJsonp([1,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(17);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(13);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: 'body',
	  components: { App: _App2.default }
	});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BraBasic = __webpack_require__(14);
	
	var _BraBasic2 = _interopRequireDefault(_BraBasic);
	
	var _BraDetail = __webpack_require__(16);
	
	var _BraDetail2 = _interopRequireDefault(_BraDetail);
	
	var _BraColor = __webpack_require__(15);
	
	var _BraColor2 = _interopRequireDefault(_BraColor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    BraBasic: _BraBasic2.default, BraDetail: _BraDetail2.default, BraColor: _BraColor2.default
	  },
	  data: function data() {
	    return {
	      now_page: 0,
	      bra: {
	        color: [],
	        type_color: [],
	        basic: [],
	        type_basic: [],
	        detail: [],
	        type_detail: []
	      }
	    };
	  },
	
	  methods: {
	    reload_chart: function reload_chart() {
	      switch (this.now_page) {
	        case 0:
	          this.$broadcast('reload-basic-chart');break;
	        case 1:
	          this.$broadcast('reload-color-chart');break;
	        case 2:
	          this.$broadcast('reload-detail-chart');break;
	      }
	    },
	    next: function next() {
	      this.now_page = (this.now_page + 1) % 3;
	      this.reload_chart();
	    },
	    previous: function previous() {
	      this.now_page = (this.now_page + 2) % 3;
	      this.reload_chart();
	    }
	  },
	  ready: function ready() {
	    $(".linear").height($(window).height());
	    var that = this;
	    $.getJSON('static/bra.json', function (data) {
	      var bra = that.bra;
	
	      $.each(data.basic, function (key, word) {
	        if (key !== "whole") {
	          bra.basic.push({ "value": word, "name": key + "杯" });
	          bra.type_basic.push(key + "杯");
	        }
	      });
	
	      $.each(data.color, function (key, word) {
	        if (key !== "whole") {
	          bra.color.push({ "value": word, "name": key });
	          bra.type_color.push(key);
	        }
	      });
	
	      $.each(data.detail, function (key, word) {
	        var whole = data.detail.whole;
	        if (key !== "whole" && word >= 1000) {
	          bra.detail.push((100 * word / whole).toFixed(3));
	          bra.type_detail.push(key);
	        }
	      });
	      that.bra = bra;
	      that.reload_chart();
	    });
	  }
	};

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    bra: Object
	  },
	  events: {
	    'reload-basic-chart': function reloadBasicChart() {
	      $("#basic").width(document.body.clientWidth * 0.7);
	      var chart = echarts.init(document.getElementById('basic'));
	      var option_basic = {
	        title: {
	          text: '淘宝网用户购买文胸尺寸饼状图',
	          subtext: '仅具参考意义',
	          x: 'center'
	        },
	        tooltip: {
	          trigger: 'item',
	          formatter: "{a} <br/>{b} : {c} ({d}%)"
	        },
	        legend: {
	          orient: 'horizontal',
	          y: '60px',
	          left: 'center',
	          data: this.bra.type_basic
	        },
	        series: [{
	          name: '该尺寸购买人数',
	          type: 'pie',
	          radius: '55%',
	          center: ['50%', '60%'],
	          data: this.bra.basic,
	          color: ['#EEB422', '#708090', '#FFA07A', '#8B658B', '#EE3B3B', '#6B8E23', '#5F9EA0', '#FFC125', '#696969'],
	          itemStyle: {
	            emphasis: {
	              shadowBlur: 10,
	              shadowOffsetX: 0,
	              shadowColor: 'rgba(0, 0, 0, 0.5)'
	            }
	          }
	        }]
	      };
	      chart.setOption(option_basic);
	    }
	  }
	};

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    bra: Object
	  },
	  events: {
	    'reload-color-chart': function reloadColorChart() {
	      $("#color").width(document.body.clientWidth * 0.7);
	      var chart = echarts.init(document.getElementById('color'));
	      var option_color = {
	        title: {
	          text: '淘宝网用户购买文胸颜色饼状图',
	          subtext: '仅具参考意义',
	          x: 'center'
	        },
	        tooltip: {
	          trigger: 'item',
	          formatter: "{a} <br/>{b} : {c} ({d}%)"
	        },
	        legend: {
	          orient: 'horizontal',
	          y: '60px',
	          left: 'center',
	          data: this.bra.type_color
	        },
	        series: [{
	          name: '该颜色购买人数',
	          type: 'pie',
	          radius: '55%',
	          center: ['50%', '60%'],
	          data: this.bra.color,
	          color: ['#EEB422', '#BEBEBE', '#FFA07A', '#8B658B', '#EE3B3B', '#6B8E23', '#5F9EA0', '#FFC125', '#696969'],
	          itemStyle: {
	            emphasis: {
	              shadowBlur: 10,
	              shadowOffsetX: 0,
	              shadowColor: 'rgba(0, 0, 0, 0.5)'
	            }
	          }
	        }]
	      };
	      chart.setOption(option_color);
	    }
	  }
	};

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    bra: Object
	  },
	  events: {
	    'reload-detail-chart': function reloadDetailChart() {
	      $("#detail").width(document.body.clientWidth * 0.7);
	      var chart = echarts.init(this.$el);
	      var option_detail = {
	        title: {
	          text: '各胸围尺寸所占人数柱状图',
	          x: 'center'
	        },
	        tooltip: {
	          trigger: 'axis'
	        },
	        toolbox: {
	          show: true,
	          feature: {
	            mark: { show: true },
	            dataView: { show: true, readOnly: false },
	            magicType: { show: true, type: ['line', 'bar'] },
	            restore: { show: true },
	            saveAsImage: { show: true }
	          }
	        },
	        calculable: true,
	        legend: {
	          orient: 'horizontal',
	          y: '30px',
	          left: 'center',
	          data: ['各尺寸所占人数百分比']
	        },
	        xAxis: [{
	          type: 'category',
	          data: this.bra.type_detail
	        }],
	        yAxis: [{
	          type: 'value',
	          name: '人数/%',
	          min: 0,
	          max: 20,
	          interval: 5,
	          axisLabel: {
	            formatter: '{value}'
	          }
	        }],
	        series: [{
	          name: '各尺寸所占人数百分比',
	          type: 'bar',
	          data: this.bra.detail,
	          color: '#191970'
	        }]
	      };
	      chart.setOption(option_detail);
	    }
	  }
	};

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	module.exports = " <div id=detail _v-024a5a82=\"\"></div> ";

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	module.exports = " <div id=basic _v-07f7c4b0=\"\"></div> ";

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	module.exports = " <div id=color _v-395d0536=\"\"></div> ";

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	module.exports = " <div id=app _v-d1080cca=\"\"> <div id=main _v-d1080cca=\"\"> <bra-basic :bra.sync=bra v-bind:style=\"{ display: now_page == 0 ? 'block' : 'none'}\" _v-d1080cca=\"\"></bra-basic> <bra-color :bra.sync=bra v-bind:style=\"{ display: now_page == 1 ? 'block' : 'none'}\" _v-d1080cca=\"\"></bra-color> <bra-detail :bra.sync=bra v-bind:style=\"{ display: now_page == 2 ? 'block' : 'none'}\" _v-d1080cca=\"\"></bra-detail> </div> <nav _v-d1080cca=\"\"> <ul class=pager _v-d1080cca=\"\"> <li class=previous @click=previous _v-d1080cca=\"\"> <a href=# _v-d1080cca=\"\"> <span class=\"glyphicon glyphicon-arrow-left\" aria-hidden=true style=\"font-size: 22px\" _v-d1080cca=\"\"></span> </a> </li> <li class=next @click=next _v-d1080cca=\"\"> <a href=# _v-d1080cca=\"\"> <span class=\"glyphicon glyphicon-arrow-right\" aria-hidden=true style=\"font-size: 22px\" _v-d1080cca=\"\"></span> </a> </li> </ul> </nav> </div> ";

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(8)
	__vue_script__ = __webpack_require__(1)
	__vue_template__ = __webpack_require__(12)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(6)
	__vue_script__ = __webpack_require__(2)
	__vue_template__ = __webpack_require__(10)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(7)
	__vue_script__ = __webpack_require__(3)
	__vue_template__ = __webpack_require__(11)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(5)
	__vue_script__ = __webpack_require__(4)
	__vue_template__ = __webpack_require__(9)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.9e254036b92cdd87fd7f.js